class DealerBranchCategoryDetailModel {
    // dealerBranchCategoryId: string;
    
    // dealerCategoryTypeId: string;
    
    // commissionStartDate: string;
    // bonusMultipleStartDate: string;
    // bonusMultiple: string;
    // dsfMultiple: string;
    // sapVendorNumber: string;

    createdUserId: string;
    modifiedUserId: string;
    effectiveFrom: string;
    financialWarrantyMonths: string;
    technicalWarrantyMonths: string;
    commissionPercentage: string;
    dsfValue: string;
    purchaseMultiples: string;
    clientDescription: string;
    dealerCategoryTypeId: string;
    dealerBranchId: string;
    dealerId: string;
    dealerBranchCategoryCommissionConfigId: string;

    constructor(dealerBranchCategoryDetailModel: DealerBranchCategoryDetailModel) {
        // this.dealerBranchCategoryId = dealerBranchCategoryDetailModel?.dealerBranchCategoryId != undefined ? dealerBranchCategoryDetailModel?.dealerBranchCategoryId : '';
        this.dealerBranchId = dealerBranchCategoryDetailModel?.dealerBranchId != undefined ? dealerBranchCategoryDetailModel?.dealerBranchId : '';
        this.dealerCategoryTypeId = dealerBranchCategoryDetailModel?.dealerCategoryTypeId != undefined ? dealerBranchCategoryDetailModel?.dealerCategoryTypeId : '';
        this.commissionPercentage = dealerBranchCategoryDetailModel?.commissionPercentage != undefined ? dealerBranchCategoryDetailModel?.commissionPercentage : '';
        // this.commissionStartDate = dealerBranchCategoryDetailModel?.commissionStartDate != undefined ? dealerBranchCategoryDetailModel?.commissionStartDate : '';
        // this.bonusMultipleStartDate = dealerBranchCategoryDetailModel?.bonusMultipleStartDate != undefined ? dealerBranchCategoryDetailModel?.bonusMultipleStartDate : '';
        // this.bonusMultiple = dealerBranchCategoryDetailModel?.bonusMultiple != undefined ? dealerBranchCategoryDetailModel?.bonusMultiple : '';
        // this.dsfMultiple = dealerBranchCategoryDetailModel?.dsfMultiple != undefined ? dealerBranchCategoryDetailModel?.dsfMultiple : '';
        // this.sapVendorNumber = dealerBranchCategoryDetailModel?.sapVendorNumber != undefined ? dealerBranchCategoryDetailModel?.sapVendorNumber : '';
        this.createdUserId = dealerBranchCategoryDetailModel?.createdUserId != undefined ? dealerBranchCategoryDetailModel?.createdUserId : '';
        this.modifiedUserId = dealerBranchCategoryDetailModel?.modifiedUserId != undefined ? dealerBranchCategoryDetailModel?.modifiedUserId : '';
        this.effectiveFrom = dealerBranchCategoryDetailModel?.effectiveFrom != undefined ? dealerBranchCategoryDetailModel?.effectiveFrom : '';
        this.financialWarrantyMonths = dealerBranchCategoryDetailModel?.financialWarrantyMonths != undefined ? dealerBranchCategoryDetailModel?.financialWarrantyMonths : '';
        this.technicalWarrantyMonths = dealerBranchCategoryDetailModel?.technicalWarrantyMonths != undefined ? dealerBranchCategoryDetailModel?.technicalWarrantyMonths : '';
        this.dsfValue = dealerBranchCategoryDetailModel?.dsfValue != undefined ? dealerBranchCategoryDetailModel?.dsfValue : '';
        this.purchaseMultiples = dealerBranchCategoryDetailModel?.purchaseMultiples != undefined ? dealerBranchCategoryDetailModel?.purchaseMultiples : '';
        this.clientDescription = dealerBranchCategoryDetailModel?.clientDescription != undefined ? dealerBranchCategoryDetailModel?.clientDescription : '';
        this.dealerId = dealerBranchCategoryDetailModel?.dealerId != undefined ? dealerBranchCategoryDetailModel?.dealerId : '';
        this.dealerBranchCategoryCommissionConfigId = dealerBranchCategoryDetailModel?.dealerBranchCategoryCommissionConfigId != undefined ? dealerBranchCategoryDetailModel?.dealerBranchCategoryCommissionConfigId : '';
    }
}


class DealerBranchCategoryDetailModelNew {
    sapVendorNoCatA: string;
    sapVendorNoCatC: string;
    pricingStatus:string;
    attritionThresholdRate: string;
    isMaintenanceByIIP: boolean;
    dealerCategoryTypeId: string;
    eligiblePeriodInMonth: string;
    bonusMultipleStartDate: string;
    commissionStartDate: string;
    techAreaId:string;
    warehouseId:string;
    locationId:string;
    techStockLocationNumber:string;
    warehouseName:string;
    storageLocationName:string;
    isQualifyBonus: boolean;
    dealerBranchCode:string;
    branchName:string
    
    constructor(dealerBranchCategoryDetailModelNew: DealerBranchCategoryDetailModelNew){
        this.sapVendorNoCatA = dealerBranchCategoryDetailModelNew?.sapVendorNoCatA != undefined ? dealerBranchCategoryDetailModelNew?.sapVendorNoCatA : '';
        this.sapVendorNoCatC = dealerBranchCategoryDetailModelNew?.sapVendorNoCatC != undefined ? dealerBranchCategoryDetailModelNew?.sapVendorNoCatC : '';
        this.pricingStatus = dealerBranchCategoryDetailModelNew?.pricingStatus != undefined ? dealerBranchCategoryDetailModelNew?.pricingStatus : '';
        this.attritionThresholdRate = dealerBranchCategoryDetailModelNew?.attritionThresholdRate != undefined ? dealerBranchCategoryDetailModelNew?.attritionThresholdRate : '';
        this.isMaintenanceByIIP = dealerBranchCategoryDetailModelNew?.isMaintenanceByIIP != undefined ? dealerBranchCategoryDetailModelNew?.isMaintenanceByIIP : false;
        this.dealerCategoryTypeId = dealerBranchCategoryDetailModelNew?.dealerCategoryTypeId != undefined ? dealerBranchCategoryDetailModelNew?.dealerCategoryTypeId : '';
        this.eligiblePeriodInMonth = dealerBranchCategoryDetailModelNew?.eligiblePeriodInMonth != undefined ? dealerBranchCategoryDetailModelNew?.eligiblePeriodInMonth : '';
        this.bonusMultipleStartDate = dealerBranchCategoryDetailModelNew?.bonusMultipleStartDate != undefined ? dealerBranchCategoryDetailModelNew?.bonusMultipleStartDate : '';
        this.commissionStartDate = dealerBranchCategoryDetailModelNew?.commissionStartDate != undefined ? dealerBranchCategoryDetailModelNew?.commissionStartDate : '';
        this.techAreaId = dealerBranchCategoryDetailModelNew?.techAreaId != undefined ? dealerBranchCategoryDetailModelNew?.techAreaId : '';
        this.warehouseId = dealerBranchCategoryDetailModelNew?.warehouseId != undefined ? dealerBranchCategoryDetailModelNew?.warehouseId : '';
        this.locationId = dealerBranchCategoryDetailModelNew?.locationId != undefined ? dealerBranchCategoryDetailModelNew?.locationId : '';
        this.techStockLocationNumber = dealerBranchCategoryDetailModelNew?.techStockLocationNumber != undefined ? dealerBranchCategoryDetailModelNew?.techStockLocationNumber : '';
        this.warehouseName = dealerBranchCategoryDetailModelNew?.warehouseName != undefined ? dealerBranchCategoryDetailModelNew?.warehouseName : '';
        this.storageLocationName = dealerBranchCategoryDetailModelNew?.storageLocationName != undefined ? dealerBranchCategoryDetailModelNew?.storageLocationName : '';
        this.isQualifyBonus = dealerBranchCategoryDetailModelNew?.isQualifyBonus != undefined ? dealerBranchCategoryDetailModelNew?.isQualifyBonus : false;
        this.dealerBranchCode = dealerBranchCategoryDetailModelNew?.dealerBranchCode != undefined ? dealerBranchCategoryDetailModelNew?.dealerBranchCode : '';
        this.branchName = dealerBranchCategoryDetailModelNew?.branchName != undefined ? dealerBranchCategoryDetailModelNew?.branchName : '';
    }

}
    


export { DealerBranchCategoryDetailModel, DealerBranchCategoryDetailModelNew }


